import axios from "axios";
import serviceHelper from "../../helpers/functions/service.helper";

// ENV Config
const BASE_URL = process.env.REACT_APP_EWALLET_SERVER_URL;
const APP_ID = process.env.REACT_APP_APP_ID;
const SECRET_KEY = process.env.REACT_APP_SECRET_KEY;

/**
 * Generate headers with encoded x-api-token
 */
function getHeaders() {
    const raw = `${APP_ID}|#|${SECRET_KEY}`;
    const encodedToken = btoa(raw); // Browser-safe Base64
    return {
        'x-api-token': encodedToken,
        'Content-Type': 'application/json',
        withCredentials: true,
    };
}

/**
 * Helper for GET requests
 */
async function get(path, query = {}) {
    const queryString = serviceHelper.queryString(query);
    const url = `${BASE_URL}${path}?${queryString}`;
    const headers = getHeaders();
    const response = await axios.get(url, { headers });
    return response?.data;
}

/**
 * Helper for POST requests
 */
async function post(path, body = {}) {
    const url = `${BASE_URL}${path}`;
    const headers = getHeaders();
    const response = await axios.post(url, body, { headers });
    return response?.data;
}

// Exported service functions
async function merchants(query) {
    return get(`integration/merchants_list`, query);
}

async function payment_report(query) {
    return get(`integration/merchant_payment_report`, query);
}

async function createMerchantSettlement(params) {
    return post(`integration/merchant_settlements`, params);
}
async function melon_merchants(query) {
    return get(`integration/melon/merchants`, query);
}

async function merchants_listing(query) {
    return get(`integration/merchants/list`, query);
}

async function queryMerchantById(merchant_id, query) {
    return get(`integration/merchants/${merchant_id}`, query);
}

async function updateMerchantById(merchant_id, params) {
    return post(`integration/merchants/${merchant_id}`, params);
}

async function queryUserByMerchant(merchant_id, query) {
    return get(`integration/merchant/${merchant_id}/users`, query);
}

async function merchantUserRoleListing(query) {
    return get(`integration/merchant_users/roles`, query);
}

async function addUser(merchant_id, params) {
    return post(`integration/merchant_users/${merchant_id}`, params);
}
async function editUser(merchant_id, id, params) {
    return post(`integration/merchant_users/${merchant_id}/${id}`, params);
}
async function deleteUser(id, params) {
    return post(`integration/merchant_users/delete/${id}`, params);
}
async function createMerchant(params) {
    return post(`integration/merchants`, params);
}

export default {
    merchants,
    payment_report,
    melon_merchants,
    merchants_listing,
    queryMerchantById,
    updateMerchantById,
    queryUserByMerchant,
    merchantUserRoleListing,
    addUser,
    editUser,
    deleteUser,
    createMerchant,
};
